import ParticipantListReportsContainer from "./ParticipantList.container";

export default ParticipantListReportsContainer;